import { ActionTree } from "vuex";
import { AuthState } from "./types";
import { RootState } from "../../types";

export const actions: ActionTree<AuthState, RootState> = {
  async authenticate({ commit }, { token }: { token: string }) {
    try {
      commit("setToken", token);

      return true;
    } catch (e) {
      commit("setToken", "");
      commit("setStatus", "error");

      return false;
    }
  },
  logout({ commit }) {
    commit("setToken", "");
  }
};
